/**
 * @fileoverview Agent definition for character-snapshotter-single-v2.
 *
 * This primitive agent analyzes a chapter to extract events and state changes
 * for a single character. It receives a single character's context and generates
 * a snapshot of that character's state at the end of the chapter.
 *
 * @category entities.characters.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-snapshotter-single-v2',
  kind: 'primitive',
  name: 'Character Snapshotter (Single)',
  description: 'Analyzes a chapter to extract events and state changes for a single character.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-02',
    taxonomyPath: 'entities.characters.analysis',
    usedBy: [
      'use-character-snapshotter-single-v2.ts',
    ],
    usedInComposites: [
      'character-snapshotter-v2',
    ],
    relatedAgents: [
      'chapter-entity-detector-v2',
      'personality-matcher-v2',
    ],
  },
};
